var toggle_stat_column = function(e){
  var filter = $(e.target)
  var value = ".js--clinic-stat-" + filter.data("filter-value");
  if ( filter.is(":checked") ){
    $( value ).show("slow");
  } else {
    $( value ).hide("slow");
  }
}

$(function(){
  $("#js--clinic-stats-overview-filter input:checkbox").change(toggle_stat_column);
});